import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://tv.gkmmedia.com/api';

const streamApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Attach auth token from localStorage on every request
streamApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

class StreamService {
  // Get all streams
  static async getAllStreams() {
    try {
      const response = await streamApi.get('/streams');
      return response.data;
    } catch (error) {
      console.error('Error fetching streams:', error);
      throw error;
    }
  }

  // Get stream statistics
  static async getStreamStats() {
    try {
      const response = await streamApi.get('/streams/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching stream stats:', error);
      throw error;
    }
  }

  // Get single stream
  static async getStream(id) {
    try {
      const response = await streamApi.get(`/streams/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching stream:', error);
      throw error;
    }
  }

  // Create new stream
  static async createStream(streamData) {
    try {
      const response = await streamApi.post('/streams', streamData);
      return response.data;
    } catch (error) {
      console.error('Error creating stream:', error);
      throw error;
    }
  }

  // Update stream
  static async updateStream(id, updates) {
    try {
      const response = await streamApi.put(`/streams/${id}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating stream:', error);
      throw error;
    }
  }

  // Delete stream
  static async deleteStream(id) {
    try {
      const response = await streamApi.delete(`/streams/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting stream:', error);
      throw error;
    }
  }

  // Get stream logs
  static async getStreamLogs(id, limit = 100) {
    try {
      const response = await streamApi.get(`/streams/${id}/logs`, {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching stream logs:', error);
      throw error;
    }
  }

  // Update stream status (for webhooks)
  static async updateStreamStatus(streamKey, status, metadata = {}) {
    try {
      const response = await streamApi.post(`/streams/status/${streamKey}`, {
        status,
        metadata
      });
      return response.data;
    } catch (error) {
      console.error('Error updating stream status:', error);
      throw error;
    }
  }

  // Health check
  static async healthCheck() {
    try {
      const response = await streamApi.get('/health');
      return response.data;
    } catch (error) {
      console.error('Health check failed:', error);
      throw error;
    }
  }

  // Regenerate stream key
  static async regenerateKey(id) {
    try {
      const response = await streamApi.post(`/streams/${id}/regenerate-key`);
      return response.data;
    } catch (error) {
      console.error('Error regenerating stream key:', error);
      throw error;
    }
  }
}

export default StreamService;
